
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/valentines-day-mascara",
      function () {
        return require("private-next-pages/valentines-day-mascara.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/valentines-day-mascara"])
      });
    }
  